<ion-button mode="ios" [expand]="expand ? 'block' : ''" [fill]="fill" [color]="color"
            [disabled]="disabled" (click)="click()"
            [ngClass]="{'confirm-button': size === 'normal', 'confirm-button-small': size === 'small', 'no-box-shadow': !hasBoxShadow}">
  <ng-container *ngIf="hasIcon && !frontIcon && text">
    <ng-container *ngTemplateOutlet="hasIconTemplate"></ng-container>
  </ng-container>
    <ng-container *ngIf="hasIcon && frontIcon && text">
        <ng-container *ngTemplateOutlet="frontIconTemplate"></ng-container>
    </ng-container>
    <ng-container *ngIf="hasIcon && !text">
        <ng-container *ngTemplateOutlet="iconOnlyTemplate"></ng-container>
    </ng-container>
  <ng-container *ngIf="!hasIcon">
    <ng-container *ngTemplateOutlet="noIconTemplate"></ng-container>
  </ng-container>
</ion-button>

<ng-template #hasIconTemplate>
  <div class="flex-row flex-space-between-center" style="width: 100%;">
    <div style="font-family: 'Silka Regular';" [ngStyle]="{'fontSize': fontSize}">{{text}}</div>
    <ion-icon [src]="iconUrlForView" [ngStyle]="{'fontSize': iconFontSize, 'color': iconColor}"></ion-icon>
  </div>
</ng-template>

<ng-template #frontIconTemplate>
    <ion-icon slot="start" [name]="iconName" [src]="iconUrlForView" [ngStyle]="{'fontSize': iconFontSize, 'color': iconColor}"></ion-icon>
    <div style="font-family: 'Silka Regular';" [ngStyle]="{'fontSize': fontSize}">{{text}}</div>
</ng-template>

<ng-template #iconOnlyTemplate>
    <ion-icon slot="icon-only" [name]="iconName" [src]="iconUrlForView" [ngStyle]="{'fontSize': iconFontSize, 'color': iconColor}"></ion-icon>
</ng-template>

<ng-template #noIconTemplate>
  <div style="font-family: 'Silka Regular';" [ngStyle]="{'fontSize': fontSize}">{{text}}</div>
</ng-template>
